export default "/fonts/vendor/mdui/dist/roboto/Roboto-Medium.woff?eb797abfa6a5cca2463e423c07c4f6ea";